//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-326922 - Remove feature check once SamplingCampaignSupportingResourceUpload is released.
export const getIsSamplingCampaignSupportingResourceUploadEnabled =
  createHasFeatureSelector(
    FeatureNames.SamplingCampaignSupportingResourceUpload,
  );
